export const ApiDef_PermissionAccessLevel = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map